import React from 'react';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import { Box, Collapse, Divider, Flex, Icon, Text } from '@chakra-ui/react';
import PropType from 'prop-types';

import colors from '../../../../../../styles/theme/foundation/colors';
import ChildrenType from '../../../../../../types/ChildrenType';

function FormCollapse({ dusk, title, isOpen, toggle, children }) {
  return (
    <>
      <Box py={5} width="100%" dusk={dusk}>
        <Flex
          _hover={{ cursor: 'pointer' }}
          alignItems="center"
          color={colors.primaryScale['600']}
          justify="space-between"
          width="inherit"
          onClick={toggle}
        >
          <Text textStyle="bodyLg500">{title}</Text>
          <Icon as={isOpen ? BsChevronUp : BsChevronDown} />
        </Flex>
        <Collapse animateOpacity in={isOpen}>
          <Box dusk={`${dusk}Content`} pt={5}>
            {children}
          </Box>
        </Collapse>
      </Box>
      <Divider borderBottomWidth="3px" ml={-6} pl={12} />
    </>

  );
}

FormCollapse.propTypes = {
  title: PropType.string,
  isOpen: PropType.bool,
  toggle: PropType.func,
  children: ChildrenType
};

export default FormCollapse;
